// /home/Hakyury/sites/oauth.eight-percent.com/frontend/src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useEffect } from "react";
import Home from "./component/OAuthHome";
import Header from "./component/OAuthHeader";
import Footer from "./component/OAuthFooter";
import ActivationPage from "./component/ActivationPage";
import { useInitAuth } from './hooks/useInitAuth';
import { setTokens } from "./utils/authFetch";

function App() {
  useInitAuth();

  // Обработчик сообщений от других окон (для других сайтов)
  useEffect(() => {
    const handleMessage = (event) => {
      // Принимаем сообщения только от доверенных источников
      const allowedOrigins = [
        'https://eight-percent.com',
        'https://campfire.eight-percent.com',
        'https://etoile.eight-percent.com',
        'https://frameparty.eight-percent.com',
        'https://profile.eight-percent.com',
        'https://admin.eight-percent.com',
        'http://localhost:3000',
        'http://127.0.0.1:3000',
      ];

      if (!allowedOrigins.includes(event.origin)) {
        return;
      }

      if (event.data.type === 'oauth_success') {
        const { access_token, refresh_token } = event.data;
        setTokens({ access: access_token, refresh: refresh_token });
        console.log('Tokens received via postMessage');
      }
    };

    window.addEventListener('message', handleMessage);
    
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <main className="flex-grow">
                <Home />
              </main>
              <Footer />
            </>
          } />
          <Route path="/activate/:token" element={<ActivationPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
